/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promos_SelectInputs */



/**
* | output |
* | --- |
* | "Select a promo…" |
*
* @param {Promos_SelectInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promos_select = /** @type {((inputs?: Promos_SelectInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promos_SelectInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Sélectionner une promo…")
	if (locale === "es") return /** @type {LocalizedString} */ ("Seleccionar una promo…")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Selecionar uma promo…")
	if (locale === "it") return /** @type {LocalizedString} */ ("Seleziona una promo…")
	return /** @type {LocalizedString} */ ("Select a promo…")
});